/** WooCommerce order requests whose failures telemetry has to tell apart. */
export const WOOCOMMERCE_ENDPOINTS = {
  /** POST creates the order. It is not idempotent: a request that got no response may still have created one. */
  orders: '/woocommerce/orders',
} as const;
